import * as React from 'react';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { SegmentStatusIcons } from 'interfaces/segmentStatuses';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconStatusSegment: {
      color: 'var(--light-outline)',
      marginRight: theme.spacing(1),
      width: 24,
      height: 24
    }
  })
);

type Props = {
  segmentStatus: string;
};
export const SegmentStatusIcon: React.FC<Props> = ({ segmentStatus }) => {
  const classes = useStyles();

  switch (segmentStatus) {
    case SegmentStatusIcons.ReAssessmentSubmitted:
    case SegmentStatusIcons.Submitted:
      return <PublishOutlinedIcon classes={{ root: classes.iconStatusSegment }} />;
    case SegmentStatusIcons.ReAssessmentRequired:
    case SegmentStatusIcons.ContractorActionRequired:
    case SegmentStatusIcons.DocumentExpired:
      return <ReportProblemOutlinedIcon classes={{ root: classes.iconStatusSegment }} />;
    case SegmentStatusIcons.AdditionalInformationRequested:
      return <HelpOutlineOutlinedIcon classes={{ root: classes.iconStatusSegment }} />;
    case SegmentStatusIcons.SubmittedAwaitingOthers:
    case SegmentStatusIcons.ResubmittedAwaitingOthers:
      return <HourglassEmptyIcon classes={{ root: classes.iconStatusSegment }} />;
    case SegmentStatusIcons.CompliantAwaitingOthers:
    case SegmentStatusIcons.Compliant:
    case SegmentStatusIcons.CurrentCertificationStillValid:
      return <CheckCircleOutlineOutlinedIcon classes={{ root: classes.iconStatusSegment }} />;
    case SegmentStatusIcons.Failed:
    case SegmentStatusIcons.Expired:
      return <CancelOutlinedIcon classes={{ root: classes.iconStatusSegment }} />;
    default:
      return null;
  }
};
